module.exports = __webpack_public_path__ + "static/media/notifica.46e95282.svg";